/** */
export const toFileName = (text = '', extension = '') => {
  const slug = text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${slug || 'download'}${extension ? `.${extension}` : ''}`;
};

export const downloadFile = async (url, file_name) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed with status ${response.status}`);

  const object_url = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = object_url;
  link.download = file_name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(object_url);
};
